<template>
	<div v-if="data">
		<div class="green-line">
			<div class="f34 flex flex-ai flex-jc-between">
				<div class="flex flex-ai">
					<lee-img-icon url="/images/icon/icon_31.png" size="30" color="#7ED321" class="z margin-right"></lee-img-icon>
					<div class="f22">按销量-燃料分析</div>
				</div>
				<div class="flex flex-ai">
					<el-select v-model="searchData" @change="onChangeYear">
						<el-option :value="tt.value" :label="tt.timeStr" v-for="(tt,ii) in yearList"></el-option>
					</el-select>
					<el-select class="margin-left" v-model="searchQuarterData" @change="onChangeQuarter" v-if="quarterList.length > 0">
						<el-option :value="tt.value" :label="tt.timeStr" v-for="(tt,ii) in quarterList"></el-option>
					</el-select>
				</div>
			</div>
		</div>
		<div class="margin-top-20">
			<div class="margin-top-20" v-if="data && data && data.now.content1" v-html="data.now.content1">
				{{data.now.content1 ? data.now.content1 : ''}}
			</div>
			<div class="text-center margin-top-20">
				<el-row>
					<el-col :span="24">
						<lee-bar-echarts-hor
							key="bar4"
							ref="bar4"
							:grid-bottom="10"
							:grid-top="10"
							grid-right="10%"
							height="350px"
							:show-legend="false"
							legend-orient="vertical"
							legend-pos="right"
							:show-left="true"
							:show-right="false"
						></lee-bar-echarts-hor>
					</el-col>
					<el-col :span="24">
						<lee-pie-echarts
							key="pie4_4"
							ref="pie4_4"
							:grid-bottom="30"
							height="350px"
							:show-legend="false"
							label-format="{b}:{d}%"
							label-pos="outside"
							:radius="['30%','50%']"></lee-pie-echarts>
					</el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "CarOilSale",
	data() {
		return {
			yearList: [],
			quarterList: [],
			data: null,
			searchFrom:{
				year:'',
				times:'',
				time_type:'',
			},
			searchData:'',
			searchQuarterData:''
		}
	},
	created() {
	},
	mounted() {
		this.getYears();
	},
	methods: {
		onChangeTimeType(e){
			this.searchData = '';
			this.getYears();
		},
		onChangeYear(e){
			this.getQuarter()
			// this.getMonth()
		},
		onChangeQuarter(e){
			this.getTotal1();
		},
		getYears() {
			let _this = this;

			this.$http.post({
				url: '/HydataColdCarOil/getYears',
				data: null,
				success(res) {
					_this.yearList = res;
					_this.searchData = res[0].value;
					_this.getQuarter();
					// _this.getMonth();
				}
			});
		},
		getMonth() {
			let _this = this;

			this.$http.post({
				url: '/HydataColdCarOil/getMonth',
				data: {year:this.searchData},
				success(res) {
					if(res.length > 0) {
						_this.quarterList = res;
						_this.searchQuarterData = res[0].value;
					}else{
						_this.quarterList = [];
						_this.searchQuarterData = '';
					}
					_this.getTotal1();
				}
			});
		},
		getQuarter() {
			let _this = this;

			this.$http.post({
				url: '/HydataColdCarOil/getQuarter',
				data: {year:this.searchData},
				success(res) {
					if(res.length > 0) {
						_this.quarterList = res;
						_this.searchQuarterData = res[0].value;
					}else{
						_this.quarterList = [];
						_this.searchQuarterData = '';
					}
					_this.getTotal1();
				}
			});
		},
		onClickMap(e){
			console.log(e);
		},
		getTotal1() {
			let _this = this;
			let _where = {};
			if(this.searchQuarterData && this.searchQuarterData !== '0'){
				_where.times = [this.searchQuarterData,'<=']
				_where.time_type = 'quarter';
				if(this.searchData){
					_where.year = this.searchData
				}
			}else{
				_where.time_type = 'year';
				if(this.searchData){
					_where.year = [this.searchData,'<=']
				}
			}
			this.$http.post({
				url: '/HydataColdCarOil/getData',
				data: _where,
				success(res) {
					_this.data = res;

					let _bardata4 = {bar1: [],xaxis: ['柴油','柴油混合动力','纯电动','甲醇混合动力','汽油','汽油混合动力','燃料电池','天然气','天然气混合动力']};
					let _pie4_4Data = [];
					if(res.now){
						_bardata4.bar1.push(res.now.chaiyou);
						_bardata4.bar1.push(res.now.cyhhdl);
						_bardata4.bar1.push(res.now.diandong);
						_bardata4.bar1.push(res.now.jchhdl);
						_bardata4.bar1.push(res.now.qiyou);
						_bardata4.bar1.push(res.now.qyhhdl);
						_bardata4.bar1.push(res.now.rldc);
						_bardata4.bar1.push(res.now.tianranqi);
						_bardata4.bar1.push(res.now.trqhhdl);

						_pie4_4Data.push({value: parseInt(res.now.chaiyou), name: '柴油'});
						_pie4_4Data.push({value: parseInt(res.now.cyhhdl), name: '柴油混合动力'});
						_pie4_4Data.push({value: parseInt(res.now.diandong), name: '纯电动'});
						_pie4_4Data.push({value: parseInt(res.now.jchhdl), name: '甲醇混合动力'});
						_pie4_4Data.push({value: parseInt(res.now.qiyou), name: '汽油'});
						_pie4_4Data.push({value: parseInt(res.now.qyhhdl), name: '汽油混合动力'});
						_pie4_4Data.push({value: parseInt(res.now.rldc), name: '燃料电池'});
						_pie4_4Data.push({value: parseInt(res.now.tianranqi), name: '天然气'});
						_pie4_4Data.push({value: parseInt(res.now.trqhhdl), name: '天然气混合动力'});
					}

					setTimeout(()=>{
						if (_this.$refs.bar4) {
							_this.$refs.bar4.initData(
								[
									{name: '车辆数量', type: 'bar', color: 'most', data: _bardata4.bar1, dw: '辆'},
									// {name: '同比', type: 'line', color: 'purple', data: _bardata4.line1, dw: '%'},
								],
								_bardata4.xaxis
							);
						}
						if(_this.$refs.pie4_4) {
							_this.$refs.pie4_4.initData(_pie4_4Data);
						}
					},300)
				}
			})
		},
	}
}
</script>
